export default (zipcode: string | undefined | null) => {
  if (!zipcode) {
    return null;
  }

  return zipcode.slice(0, 5);
};
